import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton } from '@mui/material';

interface PasswordVisibilityProps {
    fieldType: string
    setFieldType: any
}

export default function PasswordVisibility(props: PasswordVisibilityProps) {
    const { fieldType, setFieldType } = props

    const toogle = () => {
        if (fieldType === "password") {
            setFieldType("text")
        } else {
            setFieldType("password")
        }
    }

    return (
        <IconButton onClick={toogle}>
            {fieldType === "password" ? <VisibilityOff color="primary" /> : <Visibility color="primary" />}
        </IconButton>
    )
}
